import { useQuery } from "@tanstack/react-query";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { CouponItem } from "../../coupons.types";
import { requestCoupons } from "./getCoupons.request";

const useCoupons = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<GetListResponse<CouponItem>, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["coupons", requestParams.type, requestParams],
    queryFn: async () => await requestCoupons(requestParams),
    ...options
  });

  return { coupons: data?.data ?? [], meta: data?.meta, ...rest };
};

export default useCoupons;
